<div class="row w-100 pt-3 text-center row-title">
    <div class="bold-text blue-color align-content-center w-100 pb-3 height-title">
        COMMANDER UNE CARTE SIM @if (brand !== 'lacarte') {
        <span>OU eSIM </span>
    }
        @if (simChoiceInterface.simChoice == 4 && !supportUser) {
            <span>({{ step }}/{{ steps }})</span>
        }
    </div>
</div>
@if (step == 1) {
    <div>
        <app-sim-choice [simChoiceInterface]="simChoiceInterface" [priceDetails]="priceDetails"
                        [procedureCode]="procedureCode" [procedureStatus]="null"></app-sim-choice>
        <div class="row w-100 pt-3 text-center">
            <div class="col-12 w-100 cta_container">
                <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
                @if (simChoiceInterface.simChoice == 4 && !supportUser) {
                    <button type="button" class="cta_btn level_2 column" (click)="setStep(2)">Suivant<span></span>
                    </button>
                }
                @if (supportUser) {
                    <button type="button" class="cta_btn level_2 column"
                            (click)="setStep((simChoiceInterface.simChoice == 4) ? 2 : 3 )">Suivant<span></span>
                    </button>
                }
                @if (simChoiceInterface.simChoice == 7 && !supportUser) {
                    <button type="button" class="cta_btn level_2 column" (click)="confirmation()">Valider<span></span>
                    </button>
                }
            </div>
        </div>
    </div>
}
@if (step == 2 && simChoiceInterface.simChoice == 4) {
    <div>
        @if (shippingAddress) {
            <div class="col-12">
                Votre carte SIM sera envoyée à l'adresse suivante (livraison en France métropolitaine et Corse
                uniquement) :
                <br><br>
            </div>
        }
        @if (shippingAddress) {
            <div class="d-flex justify-content-center">
                <app-address-card [shippingAddress]="shippingAddress" [displayButton]="false"></app-address-card>
            </div>
        }
        <br>
        <br/>
        Pour modifier ou compléter votre adresse, <a routerLink="/compte/adresses/modifier/adresse-livraison">cliquez
        ici.</a> Une fois que vous l'aurez mise à jour, vous pourrez relancer la procédure de <strong>Commande de carte
        SIM</strong>.
        <br>
        La carte SIM est généralement envoyée sous 48h et livrée sous 3 à 5 jours ouvrés. À réception, rendez-vous dans
        la rubrique <strong>Gestion de ma ligne</strong> pour l'activer.
        <div class="row w-100 pt-3 text-center">
            <div class="col-12 w-100 cta_container">
                <button type="button" class="cta_cancel column" (click)="setStep(1)">Retour<span></span></button>
                @if (steps == 2 && shippingAddress) {
                    <button type="button" class="cta_btn level_2 column" (click)="confirmation()">Valider<span></span>
                    </button>
                }
                @if (steps == 3 && shippingAddress) {
                    <button type="button" class="cta_btn level_2 column" (click)="setStep(3)">Suivant<span></span>
                    </button>
                }
            </div>
        </div>
    </div>
}
@if (step == 3) {
    <div>
        <div class="row w-100 pt-3 justify-content-center">
            <span class="bold-text">Vous êtes connecté en tant que conseiller. L'envoi de la carte sim est-il gratuit ?</span>
            <br><br>
            <div class="row w-100 pt-3 text-center">
                <div class="col-12 w-100 cta_container">
                    <button type="button" class="{{ brand == 'prixtel' ? 'cta_cancel' : 'cta_btn' }} level_2 column mr-3" (click)="updateSwap(false)">
                        Non<span></span></button>
                    <button type="button" class="cta_btn level_2 column" (click)="updateSwap(true)">Oui<span></span>
                    </button>
                </div>
            </div>
        </div>
    </div>
}
